import React from 'react'
import api from './api-client'
import fileDownload from './file-download'
import { CompanyDataUploads } from './company-data-upload'
import TrickleDownUpdater from './trickle-down-updater'
import UpdateUserScores from './update-user-scores'
import UpdatePerformanceByValue from './update-performance-by-value'
import UpdatePlaidItems from './update-plaid-items'
import UpdatePlaidWebhooks from './update-plaid-webhooks'
import ReindexElasitcsearch from './reindex-elasticsearch'
import { DataDuplicator } from './indicators'
import IntroduceModeratedCompanies from './introduce-moderated-companies'
import TestExpoPushNotification from './test-expo-push-notification'
import TestCityTypeahead from './test-city-typeahead'
import TestImpressionReport from './test-impression-report'
import RunSixValuesMigration from './run-six-values-migration'

const DataPage: React.FC = () => {
  return (
    <div className="data-page container">
      <div className="data-form"><CompanyDataUploads /></div>
      <div className="data-form"><DataDuplicator /></div>

      <h4>Danger Zone</h4>
      <p>Probably talk to Justin if you feel compelled to mash any of these buttons 😜</p>
      <div className="buttons v-buttons">
        <TrickleDownUpdater />
        <RunSixValuesMigration />
        <UpdateUserScores />
        <UpdatePerformanceByValue />
        <UpdatePlaidItems />
        <UpdatePlaidWebhooks />
        <ReindexElasitcsearch />
        <TestExpoPushNotification />
        <TestCityTypeahead />
        <TestImpressionReport />
        <IntroduceModeratedCompanies />
        <button className="btn btn-primary" onClick={() => {
          api.authenticatedFetch('/api/admin/company/export', {
            responseType: 'blob'
          }).then(async res => {
            const blob = await res.blob()
            fileDownload(blob, 'first-test.csv', 'text/csv', undefined)
          }).catch(ex => console.error(ex))
        }}>Download Company CSV</button>
      </div>
    </div>
  )
}

export default DataPage